export enum recruitmentsListTypes {
  FETCH_RECRUIMENTS_LIST_REQUEST = "FETCH_RECRUIMENTS_LIST_REQUEST",
  FETCH_RECRUIMENTS_LIST_SUCCESS = "FETCH_RECRUIMENTS_LIST_SUCCESS",
  FETCH_RECRUIMENTS_LIST_FAILURE = "FETCH_RECRUIMENTS_LIST_FAILURE",
}